import globalContent from './global.content';

export default globalContent;
